import { useLayoutEffect } from "react";
export const useClientLayoutEffect = (globalThis === null || globalThis === void 0 ? void 0 : globalThis.document)
    ? useLayoutEffect
    : () => { };
//# sourceMappingURL=useClientLayoutEffect.js.map